import React from 'react';

import { angleEquals } from '@paragon/geometry-library';
import { isOverhangSignal } from '@paragon/layout';

import { formatSlope } from '../../../three/dimension/SlopeLabel';
import { useAppSelector } from '../../hooks';
import { TooltipContent, TooltipText } from './common';

export function RoofPlaneTooltip(props: { guid: string }) {
  const roofPlane = useAppSelector((state) => state.layout.roofPlanes[props.guid]);

  if (roofPlane == null) {
    console.warn('unable to find roof plane for tooltip.');
    return null;
  }

  const slopeInDegrees = Math.abs(roofPlane.slopeInDegrees);
  let prefix = '';

  if (angleEquals(slopeInDegrees, 90)) {
    prefix = 'Vertical ';
  } else if (angleEquals(slopeInDegrees, 0)) {
    prefix = 'Horizontal ';
  }

  const realCuts = roofPlane.cuts.filter((cut) => !isOverhangSignal(cut, roofPlane.guid));

  return (
    <TooltipContent>
      <TooltipText>{`${prefix}Roof Plane with ${realCuts.length} cuts`}</TooltipText>
      <TooltipText>Slope: {formatSlope(slopeInDegrees)}</TooltipText>
    </TooltipContent>
  );
}
